import React from 'react';
import { Bike, Wrench, Gauge, Clock, Zap } from 'lucide-react';

const BikeTips: React.FC = () => {
  const tips = [
    {
      icon: <Wrench size={20} className="text-green-400" />,
      title: 'Regular Maintenance',
      content: 'Clean your bike after every ride, especially in wet or muddy conditions. Check tire pressure, brake pads, and chain wear weekly.',
    },
    {
      icon: <Gauge size={20} className="text-blue-400" />,
      title: 'Proper Tire Pressure',
      content: 'For road biking, typically 80-100 PSI depending on rider weight and tire width. Lower pressure provides better traction on rough roads.',
    },
    {
      icon: <Clock size={20} className="text-orange-400" />,
      title: 'Cadence Goal',
      content: 'Aim for 80-90 RPM on flat terrain. Higher cadence reduces strain on knees and improves efficiency over long distances.',
    },
    {
      icon: <Zap size={20} className="text-purple-400" />,
      title: 'Positioning',
      content: 'Saddle height should allow a slight bend in the knee at the bottom of the pedal stroke. Handlebar reach should be comfortable, not stretched.',
    },
  ];

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2 flex items-center">
          <Bike size={28} className="mr-3 text-green-400" />
          Bike Tips
        </h1>
        <p className="text-muted">Essential cycling advice for triathletes</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {tips.map((tip, index) => (
          <div key={index} className="card-base p-6">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-[#0a0e14] rounded-lg">
                {tip.icon}
              </div>
              <div>
                <h3 className="font-semibold mb-2">{tip.title}</h3>
                <p className="text-sm text-muted">{tip.content}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card-base p-6">
        <h2 className="text-xl font-semibold mb-4">Pre-Ride Checklist</h2>
        <ul className="space-y-3 text-muted">
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 bg-green-400 rounded-full" />
            <span>Check tire pressure and inspect for cuts/wear</span>
          </li>
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 bg-green-400 rounded-full" />
            <span>Test brakes - ensure pads have life and properly aligned</span>
          </li>
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 bg-green-400 rounded-full" />
            <span>Check chain lubrication - not too dry, not too greasy</span>
          </li>
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 bg-green-400 rounded-full" />
            <span>Quick release levers closed and tight</span>
          </li>
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 bg-green-400 rounded-full" />
            <span>Helmet straps secure and fitting properly</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BikeTips;
